import './seating_chart_mobile_filter.js'
let primary_color = '#e10600'
let sec_color = '#ccc'
let hidingPackageClass = '.group-package'
const isF1ausgp = () => window.name == 'f1ausgp'
if(['motogp', 'nba-exp'].includes(window.name)){hidingPackageClass = '.seatingChartPackage'}
if(['supercars'].includes(window.name)){primary_color = '#ee3123'}


const hideAllPackages = () => {
  $('.leftside .product-item').each(function () {
    $(this).closest(hidingPackageClass).addClass('hidden')
  })
}

const filterPackages = (minVal, maxVal) => {

  hideAllPackages()

  $('.leftside .product-item').each(function () {
    let price = parseInt($(this).attr('data-price'))

    if (minVal <= price && maxVal >= price) {
      $(this).closest(hidingPackageClass).removeClass('hidden')
    }
  })
  updateAvailabilityCounter()
}

const disableSections = () => {
  Array.from(document.querySelectorAll('[data-toggle=svg-tooltip]')).forEach((elem) => {
    $(elem).css('fill', '#ccc')
  })
}

const get_section_ids = (section_ids_json) => {
  let sec_ids = section_ids_json.replace(/'/g, '"')
  sec_ids = JSON.parse(sec_ids)

  let seatingChartId = document.getElementsByClassName('seatingChartPackage')[0].getAttribute('data-seating-chart-id')
  sec_ids = sec_ids[seatingChartId]

  return Object.values(sec_ids).flat()
}

export function highlightSections(elem) {
  let section_ids_json = $(elem).find('.ticket-label').attr('data-position')
  let section_ids = []
  if (section_ids_json) {
    section_ids = get_section_ids(section_ids_json)
  }

  Array.from(document.querySelectorAll('[data-toggle=svg-tooltip]')).forEach( (elem) => {
    if(section_ids.includes(elem.getAttribute('id')))
      $(elem).css('fill', $(elem).attr('data-fill-color'))
    $(elem).removeClass('disableClick')
  })
}


$(document)
  .on('change', '.container-fluid .slider__min-slider', function () {
    $('.min-slider').blur()
    $('.max-slider').blur()

    const minVal = parseInt($(this).val())
    const maxVal = parseInt($('.slider__max-slider').val())

    filterPackages(minVal, maxVal)
  })

  .on('keyup', '.container-fluid .min-slider', function (event) {
    if (event.keyCode == 13) {
      const minVal = parseInt($(this).val().slice(1))
      const maxVal = parseInt($('.slider__max-slider').val())
      $('.min-slider').blur()
      $('.max-slider').blur()

      filterPackages(minVal, maxVal)
    }
  })

  .on('change', '.container-fluid .slider__max-slider', function () {
    $('.min-slider').blur()
    $('.max-slider').blur()

    const minVal = parseInt($('.slider__min-slider').val())
    const maxVal = parseInt($(this).val())

    filterPackages(minVal, maxVal)
  })

  .on('keyup', '.container-fluid .max-slider', function (event) {
    if (event.keyCode == 13) {
      const minVal = parseInt($('.slider__min-slider').val())
      const maxVal = parseInt($(this).val().slice(1))
      $('.min-slider').blur()
      $('.max-slider').blur()

      filterPackages(minVal, maxVal)
    }
  })


export function resetPackageType() {
  $('.product-item').each(function () {
    $(this).parent().removeClass('pkg-hidden')
    $(this).parents('.seatingChartPackage').removeClass('hidden')
  })
}

const resetPriceFilter = () => {
  $('.slider__min-slider').val(document.getElementsByClassName('slider__min-slider')[0].min)
  $('.slider__max-slider').val(document.getElementsByClassName('slider__max-slider')[0].max)

  $('.slider__max-slider').css('background', primary_color)

  $('.product-item').each(function () {
    $(this).parent().removeClass('hidden')
  })
}


const resetPackagesBySection = () => {
  $('.product-item').each(function () {
    $(this).parent().removeClass('pkg-sec-hidden')
  })

  removeRedFill()
  updateAvailabilityCounter()

}

let removeRedFill = () => {
  $('[data-toggle=svg-tooltip]').each(function () {
    $(this).removeClass('red-fill')
  })
}

let resetFilters = () => {
  resetPriceFilter()
  resetPackageType()
  resetPackagesBySection()
  resetHighlightSections()

  $('.package-type-filter .dropdown-menu .switch input').each(function () {
    $(this).prop('checked', false)
  })

  $('.buttons-wrapper .switch input').each(function () {
    $(this).prop('checked', false)
  })

  $('.group .seatingChartPackage').each(function() {
    $(this).removeClass('hidden')
  })
  updateAvailabilityCounter()
}

$(document)
  .on('click', '.reset', function () {
    resetFilters()
  })

$(document)
  .on('change', '.container-fluid #navbar-filter input[type=checkbox]', function (event) {
    const pkg_type = $(this).parents('li').attr('data-filter')
    const status = event.target.checked
    let pkg_types = []

    if (status) {
      pkg_types.push(pkg_type)
    }

    $(this).parent().parent('li').siblings().each(function () {
      //let sibling_pkg_type = $(this).attr('class')
      let sibling_pkg_type = $(this).attr('data-filter')

      let isChecked = $(this).find('input[type=checkbox]').is(':checked')

      if (isChecked) {
        pkg_types.push(sibling_pkg_type)
      } else {
        let index = pkg_types.indexOf(sibling_pkg_type)
        if (index > 0) {
          pkg_types.splice(index, 1)
        }
      }
      pkg_types = Array.from(new Set(pkg_types))
    })

    if (pkg_types.length == 0) {
      resetPackageType()
      resetHighlightSections()
      updateAvailabilityCounter()
    } else {
      $('.product-item').each(function () {
        $(this).parent().addClass('pkg-hidden')
      })

      disableSections()

      $('.product-item').each(function () {
        let categories = $(this).attr('data-category-names').split(',')
        for (let category of categories) {
          if (pkg_types.includes(category)) {
            $(this).parent().removeClass('pkg-hidden')
            highlightSections($(this))
          }
        }
      })
      updateAvailabilityCounter()
    }

  })

export function resetHighlightSections() {
  Array.from(document.querySelectorAll('[data-toggle=svg-tooltip]')).forEach((elem) => {
    $(elem).css('fill', $(elem).attr('data-fill-color'))
    $(elem).removeClass('disableClick')
  })
}


export function enableDisableFilters(data_categories) {
  Array.from(document.querySelectorAll('.navfilter li[data-filter]')).forEach((elem) => {
    let data_filter = elem.getAttribute('data-filter')
    if (data_categories.length == 0) {
      elem.querySelector('input[type=checkbox]').disabled = false
    } else {
      if (data_categories.includes(data_filter))
        elem.querySelector('input[type=checkbox]').disabled = false
      else
        elem.querySelector('input[type=checkbox]').disabled = true
    }
  })
}
let isRedesign = () => !!$('.redesign-wrapper .map-wrapper .mobile-packages-filter-heading')
let mobileFilterBtn = () => isRedesign ?
  '.map-wrapper .packages-filter .filter-btn.mobile-only' : '.mobile-packages-filter-header .filter-heading .btn-inverse'

$(document)
  .on('click', mobileFilterBtn(), function () {
    $('.packages-filter .mobile-packages-filter').addClass('open')
    if (isRedesign()) $('.redesign-wrapper .filters .secondary-filters').addClass('open')
  })

  .on('click', '.mobile-packages-filter .icon-cross', function () {
    $('.packages-filter .mobile-packages-filter').removeClass('open')
    if (isRedesign()) $('.redesign-wrapper .filters .secondary-filters').removeClass('open')
  })


$(document)
  .on('click', '.package-type-filter .dropdown-menu .switch', function (event) {
    event.stopPropagation()
  })



const sliderColor = () => {
  let minThumbVal = $('.slider__min-slider').val()
  let maxThumbVal = $('.slider__max-slider').val()

  let minVal = document.getElementsByClassName('slider__max-slider')[0].min
  let maxVal = document.getElementsByClassName('slider__max-slider')[0].max

  let minP = ((minThumbVal - minVal) / (maxVal - minVal)) * 100

  let maxP = ((maxThumbVal - minVal) / (maxVal - minVal)) * 100

  $('.slider__max-slider').css('background', 'linear-gradient(to right, ' + sec_color + ', ' + sec_color + ' ' + minP + '%, ' + primary_color + ' ' + minP + '%, ' + primary_color + ' ' + maxP + '%, ' + sec_color + ' ' + maxP + '%)')
}

$(document)
  .on('input', '.slider__min-slider', function () {
    sliderColor()
  })

  .on('input', '.slider__max-slider', function () {
    sliderColor()
  })


const filterPackagesBySection = () => {
  let sections = []
  Array.from(document.querySelectorAll('.product-item')).forEach((elem) => {
    elem.parentElement.classList.add('pkg-sec-hidden')
  })

  Array.from(document.querySelectorAll('.rightsidemap [data-toggle=svg-tooltip]')).forEach( (elem) => {
    if(elem.classList.contains('red-fill')) {
      sections.push(elem.getAttribute('id'))
    }
  })

  Array.from(document.querySelectorAll('.leftsidemap [data-toggle=svg-tooltip]')).forEach( (elem) => {
    if(elem.parentElement.classList.contains('red-fill')) {
      sections.push(elem.getAttribute('id'))
    }
  })

  Array.from(document.querySelectorAll('.product-item')).forEach( (elem) => {
    let section_ids_json = elem.getElementsByClassName('ticket-label')[0].getAttribute('data-position')
    let section_ids = []
    if (section_ids_json) {
      section_ids = get_section_ids(section_ids_json)
    }

    for (let section_id of section_ids) {
      if (sections.includes(section_id)) {
        elem.parentElement.classList.remove('pkg-sec-hidden')
      }
    }
  })
  updateAvailabilityCounter()
}

const anchorPageToPackage = () => {
  let elements = document.querySelectorAll('[data-toggle=svg-tooltip]')
  let nodesListArray = Array.from(elements)
  let selectedSection = nodesListArray.find((elem) => {
    return (elem.classList.contains('red-fill'))
  })

  let productItems = document.querySelectorAll('.product-item')
  let nextNodesListArray = Array.from(productItems)

  let firstSelectedPackage = nextNodesListArray.find((elem) => {
    let section_ids_json = elem.getElementsByClassName('ticket-label')[0].getAttribute('data-position')
    let section_ids = []
    if (section_ids_json) {
      section_ids = get_section_ids(section_ids_json)
    }

    let firstMatch = section_ids.find(section_id => {
      if (selectedSection['id'] == section_id) {
        return elem.parentElement
      }
    })
    if (firstMatch) { return firstMatch }
  })

  const yOffset = -130
  const y = firstSelectedPackage.getBoundingClientRect().top + window.pageYOffset + yOffset
  window.scrollTo({ top: y, behavior: 'smooth' })
}

document.addEventListener('turbo:load', () => {
  Array.from(document.querySelectorAll('.rightsidemap [data-toggle=svg-tooltip]')).forEach( (elem) => {
    elem.addEventListener('click', () => {
      if (elem.classList.contains('red-fill')) {
        elem.classList.remove('red-fill')
      } else {
        elem.classList.add('red-fill')
      }

      let filter =  false
      $('.rightsidemap [data-toggle=svg-tooltip]').each(function() {
        if($(this).hasClass('red-fill')) {
          filter = true
        }
      })

      let ticketSeatingChart = document.getElementById('f1-ticket-seating-chart')
      if (ticketSeatingChart) {
        anchorPageToPackage()
        removeRedFill()
      }
      else {
        if (filter) {
          filterPackagesBySection()
        } else {
          resetPackagesBySection()
        }
      }
    })
    updateAvailabilityCounter()
  })
})

document.addEventListener('turbo:load', () => {
  Array.from(document.querySelectorAll('.leftsidemap [data-toggle=svg-tooltip]')).forEach( (elem) => {
    elem.addEventListener('click', () => {
      if(elem.parentElement.classList.contains('red-fill')) {
        elem.parentElement.classList.remove('red-fill')
      } else {
        elem.parentElement.classList.add('red-fill')
      }

      let filter =  false
      $('.leftsidemap [data-toggle=svg-tooltip]').each(function() {
        if($(this).parent().hasClass('red-fill')) {
          filter = true
        }
      })

      if(filter) {
        filterPackagesBySection()
      } else {
        resetPackagesBySection()
      }
    })
  })
})

document.addEventListener('turbo:load', () => {
  if(document.getElementsByClassName('experience-ticket-hotel-bar').length > 0){
    if(document.getElementById('f1-ticket-seating-chart')){
      document.getElementsByClassName('ticket-statement-wrapper')[0].classList.add('active')
    } else {
      document.getElementsByClassName('experience-statement-wrapper')[0].classList.add('active')
    }
  }
})
const hiddenPackageCount = () => {
  if(isF1ausgp()) {
    let counter = 0
    Array.from(document.querySelectorAll('.seatingChartPackage > .group-package')).forEach((pkg) => {
      if(pkg.classList.contains('pkg-sec-hidden') ||
         pkg.classList.contains('hidden') ||
         pkg.querySelector('.group-package')?.classList.value.includes('hidden') ||
         pkg.classList.contains('pkg-hidden')) {
        counter++
      }
    })
    return counter
  } else {
    let counter = 0
    $('.seatingChartPackage').each((i, pkg) => {
      if ($(pkg).hasClass('hidden') || $(pkg).children('.group-package')[0].classList.value.includes('hidden')) {
        counter++
      }
    })
    return counter
  }
}

const soldOutPackageCount = () => {
  let counter = 0
  $('.seatingChartPackage').each((i, pkg) => {
    if ($(pkg).hasClass('product-item-sold-out') || !!$(pkg).children('.group-package').children('.product-item-sold-out')[0]) {
      counter++
    }
  })
  return counter
}

const availabilityCount = () =>{
  if ($('.seatingChartPackage .group-package').length <= hiddenPackageCount()) {
    return 0
  } else {
    return $('.seatingChartPackage .group-package').length - hiddenPackageCount() - soldOutPackageCount()
  }
}

const updateAvailabilityCounter = () => {
  const count = availabilityCount()
  const optionText = count === 1 ? 'Option' : 'Options'
  $('.redesign-wrapper .sorting-wrapper .available .dark-text, .sorting-wrapper .available .text-white').text(`${count} ${optionText} Available`)
}


$(document)
  .on('turbo:load', function () {
    let elem = document.getElementById('seating_chart_price')
    if(elem) {
      let color = window.getComputedStyle(elem, null).getPropertyValue('--slider-primary-color')
      primary_color = color ? color : '#e10600'

      color = window.getComputedStyle(elem, null).getPropertyValue('--slider-secondary-color')
      sec_color = color ? color : '#ccc'
    }
  })

$(document).on('turbo:load', function () {
  $('.sorting-wrapper .sort select').on('change', (e) => {
    if (!['htol', 'ltoh'].includes(e.target.value)) return
    let items = document.querySelectorAll('.product-item')

    let sortedItems = Array.from(items).sort((a, b) => {
      return parseFloat(a.dataset.price) - parseFloat(b.dataset.price)
    })

    if ($('.sorting-wrapper .sort select').val() == 'htol') sortedItems.reverse()

    sortedItems.forEach((item, index) => {
      item.parentElement.parentElement.style.order = index
    })
  })
})

$(document).on('turbo:load', function () {
  $('.redesign-wrapper .options-wrapper .option').on('click', (e) => {
    e.preventDefault()
    let pkg_type = e.target.parentElement.dataset['filter']

    $('.secondary-filter-wrapper .dropdown-menu li').each((i, elem) => {
      if (elem.dataset['filter'] == pkg_type) $(elem).find('.switch input').click()
    })
  })
})

document.addEventListener('turbo:load', () => {
  if(isF1ausgp()) {
    let seatingChartOptions = document.querySelectorAll('.seating_chart .options-wrapper .option')
    seatingChartOptions.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        e.preventDefault()
        let option = e.currentTarget

        if(!option.classList.contains('disabled')) {
          let pkg_type = e.target.parentElement.dataset['filter']

          document.querySelectorAll('.secondary-filter-wrapper .dropdown-menu li').forEach((elem) => {
            if (elem.dataset['filter'] == pkg_type) elem.querySelector('.switch input').click()
          })
        }
      })
    })

    let resetBtn = document.querySelector('.btn-reset')
    resetBtn.addEventListener('click', () => {
      resetFilters()
    })
  }
})
